document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.getElementById('mobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
    });
  }

  const crest = document.querySelector('[data-hero-crest]');

  if (crest) {
    const hoverSoundUrl = crest.dataset.hoverSoundUrl;
    if (hoverSoundUrl) {
      const hoverSound = new Audio(hoverSoundUrl);
      hoverSound.preload = 'auto';
      hoverSound.volume = 1;

      const playHoverSound = () => {
        try {
          hoverSound.pause();
          hoverSound.currentTime = 0;
          const playAttempt = hoverSound.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {});
          }
        } catch (_) {}
      };

      crest.addEventListener('pointerenter', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        playHoverSound();
      });
    }
  }

  const lightbox = document.querySelector('[data-product-lightbox]');
  const galleryButtons = Array.from(document.querySelectorAll('[data-product-gallery-open]'));

  if (lightbox && galleryButtons.length) {
    const lightboxImage = lightbox.querySelector('[data-product-lightbox-image]');
    const counter = lightbox.querySelector('[data-product-lightbox-counter]');
    const viewport = lightbox.querySelector('[data-product-lightbox-viewport]');
    const zoomButton = lightbox.querySelector('[data-product-lightbox-zoom]');
    const previousButton = lightbox.querySelector('[data-product-lightbox-prev]');
    const nextButton = lightbox.querySelector('[data-product-lightbox-next]');
    const closeButtons = lightbox.querySelectorAll('[data-product-lightbox-close]');
    let currentIndex = 0;
    let previouslyFocused = null;
    let actualSize = false;

    const setActualSize = (enabled) => {
      actualSize = Boolean(enabled);
      lightbox.classList.toggle('product-lightbox--actual-size', actualSize);
      if (zoomButton) {
        zoomButton.textContent = actualSize ? 'Fit to screen' : 'Actual size';
        zoomButton.setAttribute('aria-pressed', String(actualSize));
      }
      if (viewport) {
        viewport.scrollTop = 0;
        viewport.scrollLeft = 0;
      }
    };

    const showImage = (index) => {
      currentIndex = (index + galleryButtons.length) % galleryButtons.length;
      const sourceButton = galleryButtons[currentIndex];
      lightboxImage.src = sourceButton.dataset.fullSrc || '';
      lightboxImage.alt = sourceButton.dataset.fullAlt || '';
      if (counter) counter.textContent = `${currentIndex + 1} / ${galleryButtons.length}`;
      setActualSize(false);
    };

    const openLightbox = (index, trigger) => {
      previouslyFocused = trigger || document.activeElement;
      showImage(index);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-lightbox-open');
      const closeButton = lightbox.querySelector('.product-lightbox__close');
      if (closeButton) closeButton.focus();
    };

    const closeLightbox = () => {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-lightbox-open');
      lightboxImage.src = '';
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
    };

    galleryButtons.forEach((button, index) => {
      button.addEventListener('click', () => openLightbox(index, button));
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));
    if (previousButton) previousButton.addEventListener('click', () => showImage(currentIndex - 1));
    if (nextButton) nextButton.addEventListener('click', () => showImage(currentIndex + 1));
    if (zoomButton) zoomButton.addEventListener('click', () => setActualSize(!actualSize));
    if (lightboxImage) lightboxImage.addEventListener('dblclick', () => setActualSize(!actualSize));

    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      } else if (event.key === 'ArrowLeft' && galleryButtons.length > 1) {
        event.preventDefault();
        showImage(currentIndex - 1);
      } else if (event.key === 'ArrowRight' && galleryButtons.length > 1) {
        event.preventDefault();
        showImage(currentIndex + 1);
      }
    });
  }

  if (crest && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    window.addEventListener('pointermove', (event) => {
      if (window.innerWidth < 980) return;
      const x = event.clientX / window.innerWidth - 0.5;
      const y = event.clientY / window.innerHeight - 0.5;
      crest.style.transform = `rotateY(${x * 8}deg) rotateX(${y * -7}deg) translate3d(${x * 12}px, ${y * 12}px, 0)`;
    });
    window.addEventListener('pointerleave', () => {
      crest.style.transform = '';
    });
  }
});
